<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="visualizer">
    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vx-card
      v-if="false && artefact && artefact.res && !artefact.res.overall && artefact.res.error"
    >
      <h2>Note</h2>

      <vs-alert color="danger" icon="new_releases" active="true" class="mt-5">
        <p>{{artefact.res.error}}</p>
      </vs-alert>
    </vx-card>
    <vx-card
      v-if="artefact && artefact.res && artefact.res.overall && !artefact.res.error"
      :title="artefact.type + ' by ' + (artefact.mode === 'revenue' ? 'Revenue ( '+currency+' )' : 'Quantity Sold')"
      subtitle="Visualize the dictionary lookup by selecting the tags below"
    >
      <div class="flex flex-wrap items-center md:justify-between">
        <div class="flex flex-wrap">
          <vs-chip
            @click="updateVisualizer(tag)"
            class="cursor-pointer"
            :class="selectedTag(index)"
            closable
            :close-icon="selectedIcon(index)"
            v-for="(tag, index) in fetchTags()"
            :key="index"
          >
            <vs-avatar :text="tag.type" />
            {{ tag.tag }}
          </vs-chip>
        </div>
      </div>

      <vs-alert color="primary" icon="new_releases" active="true" class="mt-5" v-if="artefact.note">
        <p>{{artefact.note}}</p>
      </vs-alert>
    </vx-card>
    <div
      class="mt-base"
      v-if="artefact && artefact.res && artefact.res.overall && !artefact.res.error"
    >
      <div class="vx-row">
        <!-- LINE CHART -->
        <!-- <div class="vx-col w-full mb-base"> -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-3/5 xl:w-3/5 mb-base">
          <vx-card
            :title="'Overall Sale Trend at '+ (artefact.type === 'BDL' ? 'Brand' : 'Category')+ ' Level'"
            subtitle="Sale Trend by Week"
          >
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="375"
                :options="trendLine.chartOptions"
                :series="makeUnitStatsData()"
              />
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full lg:w-2/5 xl:w-2/5 mb-base">
          <vx-card
            :title="'List of '+(artefact.type === 'BDL' ? 'Skus' : 'Brands') +' by '+ (artefact.mode === 'revenue' ? 'Revenue ( '+currency+' )' : 'Quantity Sold')"
            subtitle="Select unit to compare weekly trend"
          >
            <template slot="actions">
              <!-- <feather-icon
                icon="XCircleIcon"
                svgClasses="w-6 h-6 text-grey"
                @click="hideAlertContainer"
              ></feather-icon> -->

              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <!-- <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideAlertContainer" /> -->

                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.consolidated.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.consolidated.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="activePrompt=true" />

                <!-- <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideAlertContainer" /> -->

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <template>
              <vs-table
                :data="units.consolidated.data"
                pagination
                max-items="5"
                search
                @selected="handleCompareSelected"
              >
                <template slot="thead">
                  <vs-th sort-key="desc" v-if="showCol('consolidated', 'desc')">Sku Desc</vs-th>
                  <vs-th sort-key="brand" v-if="showCol('consolidated', 'brand')">Brand</vs-th>
                  <vs-th sort-key="metric">Metric</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr
                    :state="applyState(tr)"
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="tr.desc" v-if="showCol('consolidated', 'desc')">
                      <small class="text-grey">{{ tr.sku_id }}</small> /
                      <small>{{ tr.desc }}</small>
                    </vs-td>
                    <vs-td :data="tr.brand" v-if="showCol('consolidated', 'brand')">{{ tr.brand }}</vs-td>
                    <vs-td :data="tr.metric">
                      <small>{{ tr.metric | numFormat}}</small>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <!-- <pre>{{buildSeries('drilled')}}</pre> -->
        <div class="vx-col w-full mb-base">
          <vx-card
            :title="'Sale Trend of '+ (artefact.type === 'BDL' ? 'Skus' : 'Brands')+ ' under '+(artefact.type === 'BDL' ? 'Brand' : 'Category')"
            subtitle="Detailed Sale Trend by Week"
          >
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts type="heatmap" :options="heatMap" :series="buildSeries('drilled')"></vue-apex-charts>
            </div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <!-- <pre>{{buildSeries('drilled')}}</pre> -->
        <div class="vx-col w-full mb-base">
          <vx-card
            :title="'Sale Contribution of '+ (artefact.type === 'BDL' ? 'Skus' : 'Brands')+ ' under '+(artefact.type === 'BDL' ? 'Brand' : 'Category')"
            subtitle="Detailed Sale Trend by Week"
          >
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="heatmap"
                :options="heatMapContrib"
                :series="buildSeries('drilled_share_table')"
              ></vue-apex-charts>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import VueApexCharts from "vue-apexcharts";
import vSelect from 'vue-select';

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      currency: this.$options.filters.currencySymbol(""),
      payload: null,
      queryTag: {},

      trendLine: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
                shade: "dark",
                inverseColors: false,
                gradientToColors: themeColors,
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            // tickAmount: 20,
            title: {
              offsetY: 10,
              text: "Week"
            },
            labels: {
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              },
              // formatter: function(val) {
              //   return "w" + Math.round(val);
              // }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text:
                this.artefact.mode === "revenue"
                  ? "Revenue ( " +
                    this.$options.filters.currencySymbol("") +
                    " )"
                  : "Quantity",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      },
      sparkLine: {
        chart: {
          height: 35,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            columnWidth: "80%"
          }
        },
        colors: themeColors,
        stroke: {
          curve: "straight"
          // width: [1]
        },
        fill: {
          opacity: 0.3
        },
        xaxis: {
          crosshairs: {
            width: 1
          }
        },
        tooltip: {
          fixed: {
            enabled: false
          },
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function(seriesName) {
                return "";
              }
            }
          },
          marker: {
            show: false
          }
        }
      },
      heatMap: {
        chart: {
          height: 350,
          type: "heatmap"
        },
        stroke: {
          width: 0
        },
        legend: {
          show: true
        },
        colors: [themeColors[0]],
        // plotOptions: {
        //   heatmap: {
        //     shadeIntensity: 0.5,
        //     // radius: 30,
        //     enableShades: false,
        //     colorScale: {
        //       ranges: [
        //         {
        //           from: -30,
        //           to: 5,
        //           name: "low",
        //           color: "#00A100"
        //         },
        //         {
        //           from: 6,
        //           to: 20,
        //           name: "medium",
        //           color: "#128FD9"
        //         },
        //         {
        //           from: 21,
        //           to: 45,
        //           name: "high",
        //           color: "#FFB200"
        //         },
        //         {
        //           from: 46,
        //           to: 55,
        //           name: "extreme",
        //           color: "#FF0000"
        //         }
        //       ]
        //     }
        //   }
        // },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"]
          }
        },
        xaxis: {
          type: "datetime",
          // tickAmount: 30,
          title: {
            offsetY: 10,
            text:
              (this.artefact.mode === "revenue"
                ? "Revenue ( " + this.$options.filters.currencySymbol("") + " )"
                : "Quantity") + " by Week"
          },
          labels: {
            // datetimeFormatter: {
            //   year: 'yyyy',
            //   month: 'MMM \'yy',
            //   day: 'dd MMM',
            //   hour: 'HH:mm'
            // },
            style: {
              cssClass: "text-grey fill-current"
            }
          },
          axisTicks: {
            show: false
          },
          // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
          // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
          // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
          // categories:[],
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          //   tickAmount: 5,
          title: {
            text: this.artefact.type === "BDL" ? "Skus" : "Brands",
            rotate: 90,
            offsetY: 0,
            offsetX: 0,
            style: { fontSize: "11px", cssClass: "" }
          },
          labels: {
            style: {
              cssClass: "text-grey fill-current"
            }
            // formatter: function(val) {
            //   return val > 999
            //     ? (val / 1000).toFixed(1) + "k"
            //     : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
            // }
          }
        },
        tooltip: {
          // shared: true,
          // intersect: false
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="p-3" style="white-space: pre-wrap !important; max-width: 250px;">' +
              "<h5><strong>" +
              (w.config.series[seriesIndex].ref
                ? w.config.series[seriesIndex].ref + " : "
                : "") +
              "</strong>" +
              series[seriesIndex][dataPointIndex] +
              " " +
              (w.config.series[seriesIndex].rep
                ? w.config.series[seriesIndex].rep
                : "") +
              "</h5>" +
              "<div><small>" +
              w.config.series[seriesIndex].desc +
              "</small></div>" +
              "</div>"
            );
          }
        }
      },
      heatMapContrib: {
        chart: {
          height: 350,
          type: "heatmap"
        },
        stroke: {
          width: 0
        },
        legend: {
          show: true
        },
        colors: [themeColors[0]],
        // plotOptions: {
        //   heatmap: {
        //     shadeIntensity: 0.5,
        //     // radius: 30,
        //     enableShades: false,
        //     colorScale: {
        //       ranges: [
        //         {
        //           from: -30,
        //           to: 5,
        //           name: "low",
        //           color: "#00A100"
        //         },
        //         {
        //           from: 6,
        //           to: 20,
        //           name: "medium",
        //           color: "#128FD9"
        //         },
        //         {
        //           from: 21,
        //           to: 45,
        //           name: "high",
        //           color: "#FFB200"
        //         },
        //         {
        //           from: 46,
        //           to: 55,
        //           name: "extreme",
        //           color: "#FF0000"
        //         }
        //       ]
        //     }
        //   }
        // },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"]
          }
        },
        xaxis: {
          type: "datetime",
          // tickAmount: 30,
          title: {
            offsetY: 10,
            text:
              (this.artefact.mode === "revenue" ? "Revenue" : "Quantity") +
              " Contribution ( % ) by Week"
          },
          labels: {
            // datetimeFormatter: {
            //   year: 'yyyy',
            //   month: 'MMM \'yy',
            //   day: 'dd MMM',
            //   hour: 'HH:mm'
            // },
            style: {
              cssClass: "text-grey fill-current"
            }
          },
          axisTicks: {
            show: false
          },
          // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
          // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
          // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
          // categories:[],
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          //   tickAmount: 5,
          title: {
            text: this.artefact.type === "BDL" ? "Skus" : "Brands",
            rotate: 90,
            offsetY: 0,
            offsetX: 0,
            style: { fontSize: "11px", cssClass: "" }
          },
          labels: {
            style: {
              cssClass: "text-grey fill-current"
            }
            // formatter: function(val) {
            //   return val > 999
            //     ? (val / 1000).toFixed(1) + "k"
            //     : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
            // }
          }
        },
        tooltip: {
          // shared: true,
          // intersect: false
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="p-3" style="white-space: pre-wrap !important; max-width: 250px;">' +
              "<h5><strong>" +
              (w.config.series[seriesIndex].ref
                ? w.config.series[seriesIndex].ref + " : "
                : "") +
              "</strong>" +
              series[seriesIndex][dataPointIndex] +
              " " +
              (w.config.series[seriesIndex].rep
                ? w.config.series[seriesIndex].rep
                : "") +
              "</h5>" +
              "<div><small>" +
              w.config.series[seriesIndex].desc +
              "</small></div>" +
              "</div>"
            );
          }
        }
      },
      units: {
        consolidated: {
          headers: [],
          data: []
        },
        drilled: {
          headers: [],
          data: []
        },
        drilled_share_table: {
          headers: [],
          data: []
        }
      },
      compareUnit: {},
      searchQuery: "",

      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      // headerTitle: ["Sku Id", "Category", "Brand", "Cost to Company","Inventory", "Action Priority"],
      // headerVal: ["sku_id", "product_category", "brand","c2c", "inventory", "Alert_Rank"],
      activePrompt: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    fetchTags() {
      let tags = [];
      let queryType = this.artefact.type;
      if (queryType === "CDL") {
        tags = this.artefact.tags.filter(t => t.type === "C");
        tags = tags;
      } else {
        tags = this.artefact.tags.filter(t => t.type === "B");
        tags = tags;
      }
      // console.log('fetchTags', tags);
      return tags;
    },
    flatTags() {
      let etags = this.fetchTags();
      console.log(etags);
      let i = 0;
      let len = etags.length;
      let flatTags = "";

      for (; i < len; i++) {
        flatTags = flatTags.concat(etags[i].tag + ", ");
      }

      console.log(flatTags);

      return flatTags.slice(0, -2);
    },
    selectedTag(pos) {
      return Number(this.queryTag) === pos
        ? "bg-primary-gradient text-white"
        : "";
    },
    selectedIcon(pos) {
      return Number(this.queryTag) === pos
        ? "check_box"
        : "check_box_outline_blank";
    },
    tagType(tag) {
      if (tag.type === "B") {
        return "Brand";
      } else if (tag.type === "C") {
        return "Category";
      } else {
        return "Brand Family";
      }
    },
    updateVisualizer(tag) {
      this.queryTag = this.fetchTags()
        .indexOf(tag)
        .toString();
      //   this.comparePerformance();
    },

    handleCompareSelected(tr) {
      this.compareUnit = ((tr.brand && tr.brand === this.compareUnit.brand) ||
        (tr.sku_id && tr.sku_id === this.compareUnit.sku_id)) ? {} : tr;
      
    },
    applyState(tr) {
      return ((tr.brand && tr.brand === this.compareUnit.brand) ||
        (tr.sku_id && tr.sku_id === this.compareUnit.sku_id))
        ? "primary"
        : "";
    },
    makeUnitStatsData() {

      let series = [];
      let chartData = {};
      let scope = this.artefact.mode === "revenue" ? "revenue" : "quantity";

      chartData = Object.assign(chartData, this.trendLine);

      let filteredUnitDataTrend = {
        name: "",
        data: []
      };

      for (let i = 0; i < this.artefact.tags.length; i++) {

        filteredUnitDataTrend.name = filteredUnitDataTrend.name
          ? filteredUnitDataTrend.name + ", " + this.artefact.tags[i].tag
          : this.artefact.tags[i].tag;
      }

      let filterAndSortData = this.filterAndSortDataForLine(
        this.artefact.res.overall
      );

      // filteredUnitDataTrend.data = this.buildPlotData(
      //   filterAndSortData,
      //   this.artefact.mode === "revenue" ? "revenue" : "quantity"
      // );

      let maxWeeks = filterAndSortData.length;

      filteredUnitDataTrend.data = this.buildseriesOfGroup(scope, maxWeeks, filterAndSortData);

      // series.push(filteredUnitDataTrend);


      series.push(filteredUnitDataTrend);

      if (this.compareUnit) {
        let filteredCompareUnitDataTrend = {
          name: "",
          data: []
        };

        let groupedUnits = this.groupedUnits(this.artefact.res.drilled);
        let groupedUnitsKeys = Object.keys(groupedUnits);
        let maxWeeks = this.findMaxWeeks(groupedUnits);

        for (let i = 0; i < groupedUnitsKeys.length; i++) {
          let data = {};
          let key = groupedUnitsKeys[i];
          if (
            (this.compareUnit.brand && this.compareUnit.brand === groupedUnits[key][0].brand) ||
            (this.compareUnit.sku_id && this.compareUnit.sku_id === groupedUnits[key][0].sku_id)
          ) {
            filteredCompareUnitDataTrend.name = groupedUnits[key][0].sku_id
              ? groupedUnits[key][0].sku_id + " / " + groupedUnits[key][0].desc
              : groupedUnits[key][0].brand;

            let filterAndSortData = this.filterAndSortDataForLine(
              groupedUnits[key]
            );

            // filteredCompareUnitDataTrend.data = this.buildPlotData(
            //   filterAndSortData,
            //   this.artefact.mode === "revenue" ? "revenue" : "quantity"
            // );

            let maxWeeks = filterAndSortData.length;

            filteredCompareUnitDataTrend.data = this.buildseriesOfGroup(scope, maxWeeks, filterAndSortData);

            break;
          }
        }

        series.push(filteredCompareUnitDataTrend);
      }

      chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return series;
    },
    filterAndSortDataForLine(data) {
      let filteredData = data.filter(t => true);

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    buildPlotData(data, type) {
      let plot = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          plot.push(data[i][type]);
        }
      }

      return plot;
    },
    buildCategoryData(data) {
      let plotCat = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type && data[i].type === "sale_trend") {
            plotCat.push(data[i].quantity);
          } else if (!data[i].type) {
            plotCat.push(data[i].quantity);
          }
        }
      }

      return plotCat;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.gridApi.paginationSetPageSize(10);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },

    buildSeries(type) {
      let series = [];

      //   let combinedUnits = this.formatItemsDataConsolidate("drilled");
      let scope = this.artefact.mode === "revenue" ? "revenue" : "quantity";
      let groupedUnits = this.groupedUnits(this.artefact.res[type]);
      let groupedUnitsKeys = Object.keys(groupedUnits);
      let maxWeeks = this.findMaxWeeks(groupedUnits);

      for (let i = 0; i < groupedUnitsKeys.length; i++) {
        let data = {};
        let key = groupedUnitsKeys[i];
        data.name = groupedUnits[key][0].sku_id
          ? groupedUnits[key][0].sku_id
          : groupedUnits[key][0].brand;

        data.desc = groupedUnits[key][0].desc
          ? groupedUnits[key][0].desc
          : groupedUnits[key][0].brand;

        data.ref = groupedUnits[key][0].sku_id
          ? groupedUnits[key][0].sku_id
          : "";

        data.rep = type !== "drilled" ? "%" : "";

        // data.data = this.generateData(18, { min: 0, max: 90 });
        data.data = this.buildseriesOfGroup(scope, maxWeeks, groupedUnits[key], type !== "drilled" ? "perc" : "");

        series.push(data);
      }

      return series;
    },

    groupedUnits(units) {
      return units.reduce(function(obj, unit) {
        // Get the unique reference for the unit group
        var unitRef = unit.sku_id ? unit.sku_id : unit.brand;

        // If the length doesn't already exist as a key in the object, create it
        if (!obj.hasOwnProperty(unitRef)) {
          obj[unitRef] = [];
        }

        // Push the number to its integer key
        obj[unitRef].push(unit);

        // Pass the object on to the next loop
        return obj;
      }, {});
    },

    findMaxWeeks(groupedUnits) {
      let groupedUnitsKeys = Object.keys(groupedUnits);
      let maxWeeks = 0;

      for (let i = 0; i < groupedUnitsKeys.length; i++) {
        let key = groupedUnitsKeys[i];
        maxWeeks =
          groupedUnits[key].length > maxWeeks
            ? groupedUnits[key].length
            : maxWeeks;
      }

      return maxWeeks;
    },

    buildseriesOfGroup(scope, maxWeeks, groupedUnit, type) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = groupedUnit[0].sale_year || 2020;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");
          let y = groupedUnit[weekIndex][scope]
            ? groupedUnit[weekIndex][scope] : 0;

          series.push({
            x: x,
            y: type === "perc" ? Math.floor(y * 100) : Math.floor(y) 
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(currentWeek === 1 ? ++currentYear : currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }

      return series;
    },

    formatRespData() {
      this.fetchUnitsConsolidate("drilled");
      this.fetchUnits("drilled_share_table");
    },
    fetchUnitsConsolidate(type) {
      this.units[type].data = this.formatItemsDataConsolidate(type);
      if (this.units[type] && this.units[type].data.length > 0) {
        this.units[type].headers = Object.keys(this.units[type].data[0]);
      }
    },
    formatItemsDataConsolidate(type) {
      let uniqueRef = {
        uniqueUnits: [],
        consolidateUnits: {
          "": []
        }
      };

      for (var i = 0; i < this.artefact.res[type].length; i++) {
        let unitRef = this.artefact.res[type][i].sku_id
          ? this.artefact.res[type][i].sku_id
          : this.artefact.res[type][i].brand;
        if (!uniqueRef.uniqueUnits.includes(unitRef)) {
          uniqueRef.consolidateUnits[unitRef] = [];
          uniqueRef.uniqueUnits.push(unitRef);
        }

        uniqueRef.consolidateUnits[unitRef].push(
          this.artefact.res[type][
            this.artefact.mode === "revenue" ? "revenue" : "quantity"
          ]
        );
      }

      let units = this.filterAndSortDataConsolidate(
        this.artefact.type,
        this.artefact.res[type],
        uniqueRef
      );
      return units;
    },
    filterAndSortDataConsolidate(type, data, uniqueRef) {
      let filteredData = data.filter(
        t => (type === "BDL" && t.sku_id) || (type === "CDL" && t.brand)
      );

      // return filteredData.sort((b, a) => a.quantity ? (a.quantity - b.quantity) : (a.revenue - b.revenue));

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    fetchUnits(type) {
      this.units[type].data = this.formatItemsData(type);
      if (this.units[type] && this.units[type].data.length > 0) {
        this.units[type].headers = Object.keys(this.units[type].data[0]);
      }
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(
        this.artefact.type,
        this.artefact.res[type]
      );
      return units;
    },
    filterAndSortData(type, data) {
      let filteredData = data.filter(
        t => (type === "BDL" && t.sku_id) || (type === "CDL" && t.brand)
      );
      return filteredData;
    },
    showCol(type, key) {
      return this.units[type].headers.includes(key);
    },

    seriesSpark(data) {
      let series = [
        {
          data: []
        }
      ];
      for (let i = 1; i < 6; i++) {
        series[0].data.push(data[i]);
      }

      // if(series[0].data.length < 1) {
      //   series[0].data = this.randomizeArray();
      // }
      return series;
    },

    buildUnitsGrid() {

      let units = [];
      let groupedUnits = this.groupedUnits(this.artefact.res["drilled"]);
      let groupedUnitsKeys = Object.keys(groupedUnits);

      for (let i = 0; i < groupedUnitsKeys.length; i++) {
        let data = {};
        let key = groupedUnitsKeys[i];

        if (groupedUnits[key][0].sku_id) {
          data.sku_id = groupedUnits[key][0].sku_id
            ? groupedUnits[key][0].sku_id
            : "";

          data.desc = groupedUnits[key][0].desc
            ? groupedUnits[key][0].desc
            : "";
        } else {
          data.brand = groupedUnits[key][0].brand
            ? groupedUnits[key][0].brand
            : "";
        }

        data.metric = groupedUnits[key].reduce(
          (total, unit) =>
            total + (unit.quantity ? unit.quantity : unit.revenue),
          0
        );

        units.push(data);
      }

      this.units.consolidated.headers = Object.keys(units[0]);
      this.units.consolidated.data = units;

      let sourceType = this.artefact.type === 'BDL' ? 'Brand' : 'Category';
      let sourceTag = this.flatTags();

      this.fileName = (this.artefact.type === 'BDL' ? 'Skus' : 'Brands') +' by '+ (this.artefact.mode === 'revenue' ? 'Revenue ( '+this.currency+' )' : 'Quantity Sold')+" For "+sourceType+"_"+sourceTag;
    },

    exportToExcel() {
      import('@/app/shared/vendor/Export2Excel').then(excel => {
        const list = this.units.consolidated.data;
        const data = this.formatJson(this.units.consolidated.headers, list)
        excel.export_json_to_excel({
          header: this.units.consolidated.headers,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    }

  },
  mounted() {
    // this.formatRespData();
    this.buildUnitsGrid();
  },
  components: {
    AgGridVue,
    VueApexCharts,
    vSelect
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
@import "@/assets/scss/vuexy/pages/profile.scss";
#visualizer {
  .tagger {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    margin-right: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
  .tasks-today-container {
    .tasks-today__task {
      transition: background 0.15s ease-out;
      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: rgba(var(--vs-primary), 0.04);
        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }

  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
